module.exports = __webpack_public_path__ + "img/marketplace_card.ccda1db4.svg";